import React from "react";
import { object, array, bool, number, string } from "prop-types";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card9.m.css";

const StoryCard9 = ({ story, aspectRatio, imageType, headerType, showAuthorName, id, showRedDot, headerLevel }) => {
  return (
    <Link href={`/${story.slug}`} className="headline-link">
      <div className="story-card story-card-9" styleName="story-card-9" id="story-card-9">
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={[400, 940]}
          sizes="(max-width: 1024px) 20vw, 100vw"
          showVideoIcon
        />
        <div styleName="card-content" className="card-content">
          <Headline
            text={story.headline}
            headerType={headerType}
            headerLevel={headerLevel}
            story={story}
            width={20}
            height={20}
            id={id}
            showRedDot={showRedDot}
          />
          <span styleName="summary" className="summary line-clamp-3">
            {story?.subheadline
              ? story?.subheadline
              : story.seo && story.seo["meta-description"]
              ? story.seo["meta-description"]
              : null}
          </span>
          <StoryDate story={story} />
        </div>
      </div>
    </Link>
  );
};

StoryCard9.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 3,
  headerLevel: 1,
  showAuthorName: false,
  showSummary: true,
  isExternalStory: false,
  showRedDot: false
};

StoryCard9.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  showAuthorName: bool,
  showSummary: bool,
  id: string,
  isExternalStory: bool,
  pageType: string,
  showRedDot: bool
};

export default StoryCard9;
